import { FC, memo } from "react";
import { styled } from "@mui/material";
import { LandingHeader } from "../components/landing/header";
import { Hero } from "../components/landing/hero";
import { PersonalNote } from "../components/landing/personal-note";
import { Publications } from "../components/landing/publications";
import { Recordings } from "../components/landing/recordings";
import { Books } from "../components/landing/books";
import { LandingFooter } from "../components/landing/footer";
import { bg } from "../styles/landing-tokens";

const Page = styled("main")({
  background: bg,
  /* `clip` not `hidden`: clips horizontal overflow without becoming a scroll
     container, which would otherwise break the sticky heading in Publications. */
  overflowX: "clip",
});

export const MainPage: FC = memo(() => (
  <Page>
    <LandingHeader />
    <Hero />
    <PersonalNote />
    <Publications />
    <Recordings />
    <Books />
    <LandingFooter />
  </Page>
));
